import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeExperiencesHandlers from "../../../context/resume/hooks/resume-experiences-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function AddExperienceRole(
    {
        parentOrder
    }
) {
    const { translations } = useContext( TranslationContext );
    const { handleAddRole } = useResumeExperiencesHandlers();

    return (
        <button className="btn_primary" onClick={ () => handleAddRole( parentOrder ) }>
            <MDBIcon fas icon="plus-circle" title={ translations.experiencesSection.addRoleLabel } color='light' size='sm'/>
            <span className='ms-1'>{ translations.experiencesSection.addRoleLabel }</span>
        </button>
    )
}
